import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringToTime', standalone: true })
export class StringToTimePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }
        const arr = value.split(':');
        if (Number(arr[0]) > 12) {
            arr[0] = (Number(arr[0]) - 12).toString();
            return `${arr[0]}:${arr[1]} PM`;
        } else if (Number(arr[0]) === 12) {
            return `${arr[0]}:${arr[1]} PM`;
        } else if (Number(arr[0]) === 0) {
            return `12:${arr[1]} AM`;
        }
        return `${arr[0]}:${arr[1]} AM`;
    }
}
